import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const TimeRangesContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp16};
  align-items: center;

  & > svg {
    margin-top: -16px;
    cursor: pointer;
  }
`
